import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-messervices',
  templateUrl: './messervices.component.html',
  styleUrls: ['./messervices.component.scss']
})
export class MesservicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
